import type { Lead } from '../../types/crm'
import { getLeadDisplayName } from './leadDisplay'
import { getProspect } from './unifiedLeadFields'

export function matchesSearch(lead: Lead, query: string): boolean {
  const needle = query.trim().toLocaleLowerCase()
  if (!needle) return true

  const organization = lead.organization
  const opportunity = lead.opportunity
  const prospect = getProspect(lead)

  // A typed phone number matches however the sheet formats it.
  const needleDigits = needle.replace(/\D/g, '')
  if (needleDigits.length >= 7) {
    const phones = [organization?.phone, prospect?.phone]
    if (phones.some((value) => value?.replace(/\D/g, '').includes(needleDigits))) return true
  }

  return [
    getLeadDisplayName(lead),
    lead.company,
    lead.owner,
    organization?.email,
    organization?.phone,
    organization?.city,
    organization?.state,
    organization?.accountManager,
    opportunity?.source,
    opportunity?.stage,
    // Prospecting-only leads carry their contact details on the prospect record,
    // so the same search finds them by name, email, phone or website.
    prospect?.person,
    prospect?.email,
    prospect?.phone,
    prospect?.website,
    prospect?.profile,
    prospect?.niche,
    prospect?.team,
    prospect?.needs,
  ].some((value) => value?.toLocaleLowerCase().includes(needle))
}
